import { Core } from "@faire/design-tokens";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import React from "react";
import styled from "styled-components";

export const RowWithBullet: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <li>
      <Row style={{ width: "100%" }}>
        <Bullet />
        <Spacer width="1x" />
        {children}
      </Row>
    </li>
  );
};

const Bullet = styled.div`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: ${Core.surface.default};
  margin: 6px 0;
  padding: 3px;
`;
